export default __webpack_public_path__ + "assets/models/4d7901d60f130c395268de7bab55b05e.glb";